import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { mapStateToProps } from "../../redux/reducers";
import PropTypes from "prop-types";
import LoginComponent from "../user/login/login";
import AdminLoginComponent from "../user/login/admin-login";
import '../../styles/bluebanner.scss';
import { AppBar, Grid, Menu, MenuItem } from '@mui/material';
// import Button from '@mui/material/Button';
import LanguageSelect from '../common/language/languageSelect';
import HelpComponent from "../../pages/user/help";
import { Link, useNavigate } from 'react-router-dom';
import { authUserDetails, tokenRevoke } from '../../redux/actionTypes/auth';
import ForgotPwdComponent from '../user/forgotpassword/forgotpassword';
import { pageRefresh,azureLogin, azureLogOut, popUpAlert } from '../../utils/globalMethods';
import { Button, Dropdown} from 'react-bootstrap';
//Azure
import { useMsal } from "@azure/msal-react";
// Cookie
import { useCookies } from 'react-cookie';


const BlueBanner = (props) => {
  const navigate = useNavigate();

  const [language, setLanguage] = useState({});
  const [helpModalShow, setHelpModalShow] = useState(false);

  const [modalShown, toggleModal] = useState(false);
  const [modalShownAdmin, toggleModalAdmin] = useState(false);
  const [forgotShown, toggleForgotModal] = useState(false);
  // const [state, dispatch] = useReducer(reducer, initialState);
  const [fullName, setFullName] = useState(null);
  const [menuList, SetMenuList] = useState(false);
  const [pathname, setPathName] = useState(window.location.pathname);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  const [mystoreUrl, setMystoreUrl] = useState();
  const [csaSignupLink, setCsaSignupLink] = useState("/dtafinder/csa-signup");
  const [cookies, setCookie, removeCookie] = useCookies(['relogin','validation','createCSA']);
// eslint-disable-next-line no-unused-vars
  const [transformStyle, setTransformStyle] = useState('translate3d(0px, -48px, 0px)');


  const { authenticated, user } = props.userAuth;

  // Azure
  const { instance } = useMsal();

  useEffect(() => {
    instance.addEventCallback(async (event) => {
      // Add below line as first time login and forgotpassword validation when these keys available.
      if ((event.eventType === "msal:loginSuccess" || event.eventType ==="msal:acquireTokenSuccess") && !(event.payload && event.payload.idTokenClaims && (event.payload.idTokenClaims.isForgotPassword == true || event.payload.idTokenClaims.newUser == true))) {
        const email = event.payload.account.idTokenClaims.email.toLowerCase();
        sessionStorage.setItem("username", email.trim());
        const myAccount = instance.getAccountByHomeId(event.payload.account.homeAccountId);
        instance.setActiveAccount(myAccount);
        const payload = {
          "email": email,
          "navigate": navigate,
          "ext_url":"csa",
          "currentAccount": instance.getActiveAccount()
        }
        props.authUserDetails(payload)
      }else if(event.payload && event.payload.idTokenClaims && (event.payload.idTokenClaims.isForgotPassword == true || event.payload.idTokenClaims.newUser == true)){
        setCookie("relogin",true);
        popUpAlert({
          title: event.payload.idTokenClaims.isForgotPassword ? "Password Updated!" : "Account Created!",
          text: "Please Login again to proceed.",
          icon: "success",
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: "Login",
          closeOnConfirm: false,
          allowOutsideClick: false,
          onConfirmed: true,
          handleConfirm: () => {
            if (event.payload.idTokenClaims.isForgotPassword) {
              azureLogin(instance);
            } else {
              azureLogOut(instance);
            }
          },
        });
      }
      // Add below line as first time login and forgotpassword validation when these keys available.
      if (event.eventType === "msal:loginFailure" || event.eventType === "msal:acquireTokenFailure") {
        azureLogOut(instance);
      }
    }, error => {
      console.log('error', error);
    });
  }, [instance]);

  useEffect(() => {
    if (cookies.relogin) {
      if(instance.getActiveAccount()){
        azureLogOut(instance);
      }else{
        removeCookie("relogin");
        setTimeout(() => {
          azureLogin(instance);
        }, 300);
      }
    }
  }, [])

 
  useEffect(() => {
    if (authenticated && Object.keys(user).length == 0) {
      sessionStorage.setItem("ext_url","res");
      const payload = {
        "email": authenticated,
        navigate: navigate,
        "ext_url":"res",
      }
      props.authUserDetails(payload);
    }
  }, [props.userAuth.authenticated])

  useEffect(() => {
    if (Object.keys(user).length != 0) {
      setFullName(user.Name)
    }
    const link = "/dtafinder/csa-signup?loginId=" + props ?.userAuth ?.user ?.id;
    setCsaSignupLink(link);
  }, [props.userAuth.user])

  useEffect(() => {
    setLanguage(props.language)
  }, [props.language]);

  useEffect(() => {
    setPathName(window.location.pathname)
  }, [window.location.pathname])

  useEffect(() => {
    const pathList = pathname.split('/')
    SetMenuList(pathList.includes("dtahip") && !pathList.includes("dtafinder"));
    let path = pathList[pathList.length - 1]
    if (pathname.slice(-1) == "/") {
      path = pathList[pathList.length - 2]
    }

    if (user.Role === "HIPVDR" || user.Role === "VENDOR") {
      setMystoreUrl("/dtahip/mystore/hip");
    } else {
      setMystoreUrl("/dtahip/mystore/csa");
    }

    if (user.Role === "HIPVDR" || user.Role === "VENDOR" || user.Role === "CSAVDR" || user.Role === "SUBVDR") {
      if (!(path == "" || path == "dtahip" || path == "mystore" || path == "hip" || path == "csa" || pathname == "/dtafinder/csa-landing" || pathname == "/dtafinder/client-agreement" || pathname.includes("/dtafinder/csa-signup"))) {
        navigate("/dtahip");
      }
    } else if (Object.keys(user).length == 0) {
      if (!(path == "" || path == "dtahip" || path == "registration" || pathname == "/dtafinder/csa-landing" || pathname == "/dtafinder/client-agreement" || pathname.includes("/dtafinder/csa-signup"))) {
        navigate("/dtahip");
      }
    }


  }, [pathname]);



  const tokenRevoke = () => {
    const payload = {
      navigate: navigate
    };
    props.tokenRevoke(payload);
  }

  useEffect(() => {
    if (props?.userAuth?.tokenRevoke && props?.userAuth?.tokenRevoke?.status == "SUCCESS") {
      pageRefresh();
    }
  }, [props.userAuth.tokenRevoke]);
  const openLogin = () => {
    setAnchorEl2(null);
    toggleModal(true);
  };


  const openForgotPwd = () => {
    toggleForgotModal(true);
  };

  const toggleHelpModal = () => {
    setHelpModalShow(true);
  }

  const stlyedHeader = {
    backgroundColor: '#14558F',
    // borderBottom: "5px solid #006e52",
    color: '#ffffff',
    // padding: "8px 0px"
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [anchorEl3, setAnchorEl3] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuOpen2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleMenuClose2 = () => {
    setAnchorEl2(null);
  };

  const handleMenuOpen3 = (event) => {
    setAnchorEl3(event.currentTarget);
  };

  const handleMenuClose3 = () => {
    setAnchorEl3(null);
  };

useEffect(() => {
  const handleResize = () => {
    const viewHeight = window.innerHeight;

    if(viewHeight <= 370) {
      setTransformStyle('translate3d(0px, -48px, 0px)');
    } else {
      setTransformStyle('translate3d(0px, 47.5px, 0px)');
    }
  }

  handleResize();

  window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };


},[]);

  return (<>
    {forgotShown ?
      (
        <ForgotPwdComponent
          shown={forgotShown}
          close={() => {
            toggleForgotModal(false);
          }}
        />
      )
      : (
        ""
      )}
    {helpModalShow ?
      (
        <HelpComponent
          shown={helpModalShow}
          close={() => {
            setHelpModalShow(false);
          }}
          language={language}
        />
      )
      : (
        ""
      )}
    <Grid container item xs={12} className='blue-wrapper'>
      {modalShown && (
        <LoginComponent
          shown={modalShown}
          close={(forgotpwd = "") => {
            toggleModal(false);
            if (forgotpwd) {
              openForgotPwd();
            }
          }}
          language={language}
        />
      )}
      {modalShownAdmin && (
        <AdminLoginComponent
          shown={modalShownAdmin}
          close={(forgotpwd = "") => {
            toggleModalAdmin(false);
            if (forgotpwd) {
              openForgotPwd();
            }
          }}
          language={language}
        />
      )}
      {(authenticated && menuList) ? (
        // <Grid container maxWidth="lg" className="wrapper-bluebanner">
      <>
        <Grid item xs={12} sx={{ mx: 2 }} display={{ xs: 'none', md: 'block' }} className="banner div-center blue-menu  ">
          <AppBar className='blue-header-root' position="static" sx={stlyedHeader} >
            {(user.Role === "ADMIN" || user.Role === "HIPCRD") &&
              <>
                <Button className='menu-item mr-3 font-regular16 textTransform-capitalize' href="/dtahip/admin-dashboard" tabIndex={0}>Dashboard</Button>
                <Button className='menu-item mr-3 font-regular16 textTransform-capitalize' href='/dtahip/manage-vendors'>Vendors</Button>
                {user.Role === "ADMIN" && <>
                  <Button className='menu-item mr-3 font-regular16 textTransform-capitalize'
                    onClick={handleMenuOpen}>
                    <span>Administration</span>
                    <i className="fa fa-caret-down caretIcon-position" aria-hidden="true"></i>
                  </Button>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem className='language-menu-item font-regular16' onClick={handleMenuClose}>
                      <Link to={"/dtahip/manage-users"} style={{ textDecoration: 'none', color: 'inherit' }}>
                        Manage Users
                      </Link>
                    </MenuItem>
                    <MenuItem className='language-menu-item font-regular16' onClick={handleMenuClose}>
                      <Link to={"/dtahip/manage-farmer-markets"} style={{ textDecoration: 'none', color: 'inherit' }}>
                        Manage Farmer Markets
                      </Link>
                    </MenuItem>
                    <MenuItem className='language-menu-item font-regular16' onClick={handleMenuClose}>
                      <Link to={"/dtahip/manage-address"} style={{ textDecoration: 'none', color: 'inherit' }}>
                        Manage Coordinates
                      </Link>
                    </MenuItem>
                    <MenuItem className='language-menu-item font-regular16' onClick={handleMenuClose}>
                      <Link to={csaSignupLink} style={{ textDecoration: 'none', color: 'inherit' }}>
                        CSA Signup
                      </Link>
                    </MenuItem>
                    <MenuItem className='language-menu-item font-regular16' onClick={handleMenuClose}>
                      <Link to={"/dtahip/partial-signup"} style={{ textDecoration: 'none', color: 'inherit' }}>
                      Partial Signup
                      </Link>
                    </MenuItem>
                    <MenuItem className='language-menu-item font-regular16' onClick={handleMenuClose}>
                      <Link to={"/dtahip/csa-signup-status"} style={{ textDecoration: 'none', color: 'inherit' }}>
                      CSA Signup Status
                      </Link>
                    </MenuItem>
                    <MenuItem className='language-menu-item font-regular16' onClick={handleMenuClose}>
                      <Link to={"/dtahip/manage-payments"} style={{ textDecoration: 'none', color: 'inherit' }}>
                      Manage Payments
                      </Link>
                    </MenuItem>
                    <MenuItem className='language-menu-item font-regular16' onClick={handleMenuClose}>
                      <Link to={"/dtahip/audit-logs"} style={{ textDecoration: 'none', color: 'inherit' }}>
                        Audit Logs
                      </Link>
                    </MenuItem>
                  </Menu>
                </>}
              </>}
              <Button className='menu-item textTransform-capitalize' onClick={handleMenuOpen3}>
                <span className="d-inline-block  mr-2" >
                  <i className="fa fa-user" aria-hidden="true"></i>{" "}
                  {fullName}</span> {"  "}
                  <i className="fa fa-caret-down caretIcon-position" aria-hidden="true"></i>
              </Button>
              <Menu
                id="simple-user"
                anchorEl={anchorEl3}
                keepMounted
                open={Boolean(anchorEl3)}
                onClose={handleMenuClose3}
              >
                {(user.Role === "HIPVDR" || user.Role === "VENDOR" || user.Role === "CSAVDR" || user.Role === "SUBVDR")  && <MenuItem className='language-menu-item font-regular16'>
                  <Link to={mystoreUrl} style={{ textDecoration: 'none', color: 'inherit' }}>My Business</Link>
                </MenuItem>}
                <MenuItem className='language-menu-item font-regular16' onClick={() =>{
                  if (user.Role === "HIPVDR" || user.Role === "VENDOR") 
                    tokenRevoke();
                  else 
                    azureLogOut(instance);
                }}>Logout</MenuItem>
              </Menu>
          </AppBar>
        </Grid>
        <Grid item className='blue-hamburger'>
         <nav className="header navbar navbar-expand-lg navbar-light blue-wrapper">
           <button className="navbar-toggler" type="button" aria-expanded={!isNavCollapsed ? true : false} aria-label="Toggle navigation" onClick={handleNavCollapse}>
             <span className="navbar-toggler-icon">
             </span>
           </button>
           <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`}  id="navbarSupportedContent">
             <ul className="navbar-nav topMenu ml-auto mt-4">
             {(user.Role==="ADMIN" || user.Role==="HIPCRD") &&
               <>
                 <li className="nav-item dropdown">
                   <a
                     href="/dtahip/admin-dashboard"
                     className="btn btn-outline-primary btn-block pl-3 text-left nav-text  width-100"
                   >
                     Dashboard
                   </a>
                 </li>
                 <li className="nav-item dropdown">
                   <a
                     // onClick={openLogin}
                     href="/dtahip/manage-vendors"
                     className="btn btn-outline-primary btn-block pl-3 text-left nav-text width-100"
                   >
                     Vendors
                   </a>
                 </li>
                 {user.Role==="ADMIN" && <li className="nav-item dropdown">
                   <Dropdown>
                     < Dropdown.Toggle className="nav-text">
                       <span className="d-inline-block mr-3 font-medium16">Administration</span>
                       <small className="fa fa-chevron-down mt-2"></small>
                     </Dropdown.Toggle>
                     <Dropdown.Menu className='dropdownMenu' style={{border:'1px solid #006e52'}}>
                       <Dropdown.Item href="/dtahip/manage-users">
                         Manage Users
                       </Dropdown.Item>
                       <Dropdown.Item href="/dtahip/manage-farmer-markets">
                         Manage Farmer Markets
                       </Dropdown.Item>
                       <Dropdown.Item  href="/dtahip/manage-address">
                         Manage Coordinates
                       </Dropdown.Item>
                       <Dropdown.Item href={csaSignupLink}>
                            CSA Signup
                        </Dropdown.Item>
                        <Dropdown.Item href="/dtahip/partial-signup">
                            Partial Signup
                        </Dropdown.Item>
                        <Dropdown.Item href="/dtahip/csa-signup-status">
                            CSA Signup Status
                        </Dropdown.Item>
                        <Dropdown.Item href="/dtahip/manage-payments">
                            Manage Payments
                        </Dropdown.Item>
                       <Dropdown.Item href="/dtahip/audit-logs">
                         Audit Logs
                       </Dropdown.Item>
                     </Dropdown.Menu>
                   </Dropdown>
                 </li>}
               </>}
               <li className="nav-item dropdown">
                 <Dropdown>
                   <Dropdown.Toggle className="nav-text">
                     <span className="d-inline-block mr-3 font-medium16" >
                       <i className="fa fa-user" aria-hidden="true"></i>{" "}
                       {fullName}</span> {"  "}
                     <small className="fa fa-chevron-down mt-2"></small>
                   </Dropdown.Toggle>
                   {/* <Dropdown.Menu style={{border:'1px solid #006e52'}}>
                     {user.Role==="VENDOR" && <Dropdown.Item href="/dtahip/mystore">My Business</Dropdown.Item>}
                     <Dropdown.Item onClick={() => {tokenRevoke();}}>Logout</Dropdown.Item>
                   </Dropdown.Menu> */}
                    <Dropdown.Menu style={{border:'1px solid #006e52'}} >
                      {(user.Role === "HIPVDR" || user.Role === "VENDOR" || user.Role === "CSAVDR" || user.Role === "SUBVDR") && <Dropdown.Item href={mystoreUrl}>My Business</Dropdown.Item>}
                      <Dropdown.Item onClick={() => { 
                        if (user.Role === "HIPVDR" || user.Role === "VENDOR") 
                          tokenRevoke();
                        else 
                          azureLogOut(instance);
                      }}>Logout</Dropdown.Item>
                    </Dropdown.Menu>
                 </Dropdown>
               </li>
             </ul>
           </div>
         </nav>
        </Grid>
      </>
      ) : (<>
        <Grid item xs={12} sx={{ mx: 2 }} display={{ xs: 'none', md: 'block' }} className="banner div-center  blue-menu">
          {/* <Grid item xs={12} sx={{ mx: 2,cursor: 'pointer' }} display="flex" alignItems="center"> */}
          <AppBar className='blue-header-root' position="static" sx={stlyedHeader} >
            {/* <span className="sr-only">Header Section</span> */}
            {(!cookies.validation || !pathname.includes("registration") || !cookies.createCSA) && <>
            <Button
            
              className='menu-item mr-3 font-regular16 textTransform-capitalize'
              onClick={handleMenuOpen}
              aria-label={`${language.Services} Service Have The Popup Listbox`}
            > 
              <span >{language.Services}</span>
              <i className="fa fa-caret-down caretIcon-position" aria-hidden="true"></i>
            </Button>
              
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              aria-haspopup="false"
              aria-owns={anchorEl ? "simple-menu" : undefined}
            >
                <MenuItem className='language-menu-item font-regular16' onClick={() => {window.location.href='/dtahip'}}>
                    {language.HealthyIncentivesProgram} {language.hip}
                </MenuItem>
                <MenuItem className='language-menu-item font-regular16' onClick={() => {window.location.href='/dtafinder/csa-landing'}}>
                    {language.communitySupportedAgriculture} {language.csa}
                </MenuItem>
            </Menu>
            </>}
            <span className='nav-item'>
              <LanguageSelect className='menu-item font-regular16' />
            </span>
              {(!cookies.validation || !pathname.includes("registration") || !cookies.createCSA) && <Button
                className='menu-item mr-3 font-regular16 textTransform-capitalize' 
                aria-label='For Providers have popup list box'
                onClick={handleMenuOpen2}
              >
                <span className='mr-2'>{language["For Providers"]}</span>
                <i className="fa fa-caret-down caretIcon-position" aria-hidden="true"></i>
              </Button>}
              <Menu
                id="menu2"
                anchorEl={anchorEl2} 
                keepMounted
                open={Boolean(anchorEl2)}
                onClose={handleMenuClose2}
              >
                <MenuItem className='language-menu-item font-regular16' onClick={() => { openLogin() }}>{language.HealthyIncentivesProgram} {language.hip}</MenuItem>
                <MenuItem className='language-menu-item font-regular16' 
                onClick={() => { 
                    azureLogin(instance);
                    sessionStorage.setItem("ext_url","csa");
                 }}>{language.communitySupportedAgriculture} {language.csa}</MenuItem>
              </Menu>
            {menuList && (<>
              <Button className="menu-item textTransform-capitalize" onClick={toggleHelpModal}>
                <span>{language.help}&nbsp;</span>
                <i className="fa fa-question-circle"></i>
              </Button>
            </>)}
          </AppBar>
        </Grid>
        <Grid item className='blue-hamburger'>
                  <nav className="header navbar navbar-expand-lg navbar-light blue-wrapper">
                    <button className="navbar-toggler" type="button" aria-expanded={!isNavCollapsed ? true : false} aria-label="Toggle navigation" onClick={handleNavCollapse}>
                      <span className="navbar-toggler-icon">
                      </span>
                    </button>
                    <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`}  id="navbarSupportedContent">
                      <ul className="navbar-nav topMenu ml-auto">
                        <li className="nav-item dropdown">
                          <Dropdown>
                          {(!cookies.validation || !pathname.includes("registration") || !cookies.createCSA) &&
                            < Dropdown.Toggle className="nav-text width-100 text-left">
                              <span className="d-inline-block mr-3">{language.Services}</span>
                              <small className="fa fa-chevron-down mt-2"></small>
                            </Dropdown.Toggle>}
                            <Dropdown.Menu>
                              <Dropdown.Item href="/dtahip">
                              {language.HealthyIncentivesProgram} {language.hip}
                              </Dropdown.Item>
                              <Dropdown.Item href="/dtafinder/csa-landing">
                                {language.communitySupportedAgriculture} {language.csa}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                        <li className="nav-item dropdown">
                          <LanguageSelect className="form-control language-select border-brand menu-item" />
                        </li>
                            <li className="nav-item dropdown">
                              <Dropdown>
                              {(!cookies.validation || !pathname.includes("registration") || !cookies.createCSA) && < Dropdown.Toggle className="nav-text width-100 text-left">
                                  <span className="d-inline-block mr-3  ">{language["For Providers"]}</span>
                                  <small className="fa fa-chevron-down mt-2"></small>
                                </Dropdown.Toggle>}
                                <Dropdown.Menu>
                                  <Dropdown.Item onClick={() => {openLogin()}}>
                                  {language.HealthyIncentivesProgram} {language.hip}
                                  </Dropdown.Item>
                                  <Dropdown.Item onClick={() => { 
                                    azureLogin(instance);
                                    sessionStorage.setItem("ext_url","csa");
                                  }}>
                                    {language.communitySupportedAgriculture} {language.csa}
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </li>
                            {menuList && (
                            <>
                            <li className="nav-item">
                              <button
                                tabIndex="0"
                                onClick={toggleHelpModal}
                                className="nav-text btn button-outline btn-block pl-3 text-left width-100"
                              >
                                <span className="d-inline-block mr-3">{language.help}</span> 
                                <small className="fa fa-question-circle mt-2"></small>
                              </button>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  </nav>
                </Grid>
      </>)}
    </Grid>
  </>
  )

}

BlueBanner.propTypes = {
  vendorDetails: PropTypes.object,
  language: PropTypes.object,
  mapdata: PropTypes.object,
  selectedLanguage: PropTypes.string,
  userAuth: PropTypes.object,
  authUserDetails: PropTypes.func,
  tokenRevoke: PropTypes.func.isRequired

};

function mapDispatchToProps(dispatch) {
  return {
    authUserDetails: (payload) => dispatch(authUserDetails(payload)),
    tokenRevoke: (payload) => dispatch(tokenRevoke(payload))

  };
}
export default connect(mapStateToProps, mapDispatchToProps)(BlueBanner);